import { request } from "../libs/http/http";

export const paginate = (url, data={}) =>{
    return request('post',url,data);
}
